<template>
    <div class="saveOrUpdateCrud">
        <div>
            <el-page-header @back="close" content="修改学生信息表"></el-page-header>
        </div>
        <el-form :model="upsertForm"  :rules="rules" ref="upsertForm" label-width="80px" style="margin-top: 20px;" >
            <input type="hidden" :value="upsertForm.id">
                      <el-form-item label="序号" prop="sequence">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.sequence" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="学号" prop="studentId">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.studentId" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="考生姓名" prop="name">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.name" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="身份证号" prop="idCard">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.idCard" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="出生日期" prop="birthday">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.birthday" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="性别" prop="sex">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.sex" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="民族" prop="nation">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.nation" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="政治面貌" prop="politicalAffiliation">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.politicalAffiliation" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="照片" prop="faceImg">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.faceImg" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="联系电话" prop="phone">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.phone" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="邮编" prop="adressCode">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.adressCode" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="联系地址" prop="address">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.address" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="准考证号" prop="ticketNumber">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.ticketNumber" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="登录密码" prop="password">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.password" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="毕业学校" prop="univerColleges">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.univerColleges" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="毕业学校" prop="unicerCollegesCode">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.unicerCollegesCode" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="报考院校" prop="studyColleges">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.studyColleges" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="报考院校" prop="studyCollegesCode">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.studyCollegesCode" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="毕业专业" prop="studyMajor">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.studyMajor" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="报考专业" prop="examMajor">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.examMajor" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="高考报名" prop="studyCode">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.studyCode" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="在校期间" prop="reward">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.reward" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="特长" prop="speciality">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.speciality" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="备注" prop="remark">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.remark" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="报名序号" prop="studySequence">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.studySequence" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="审核状态" prop="status">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.status" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="审核人" prop="examineName">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.examineName" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="审核时间" prop="examineTime">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.examineTime" auto-complete="off"></el-input>
                     </el-form-item>
                      <el-form-item label="审核备注" prop="examineRemark">
                         <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.examineRemark" auto-complete="off"></el-input>
                     </el-form-item>
        </el-form>
        <div class="dialog-footer" style="text-align: center;">
            <el-button plain size="mini" @click="close">取 消</el-button>
            <el-button plain size="mini" type="primary" v-if="title=='增加'" v-display:sysStudentDo-save @click="saveOrUpdate('upsertForm')">确 定</el-button>
            <el-button plain size="mini" type="primary" v-else v-display:sysStudentDo-update @click="saveOrUpdate('upsertForm')">确 定</el-button>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: "saveOrUpdateSysStudent",
        props: ['title','id'],
        data(){
            return {
                upsertForm:{
                        id:'',
                        sequence:'',
                        studentId:'',
                        name:'',
                        idCard:'',
                        birthday:'',
                        sex:'',
                        nation:'',
                        politicalAffiliation:'',
                        faceImg:'',
                        phone:'',
                        adressCode:'',
                        address:'',
                        ticketNumber:'',
                        password:'',
                        univerColleges:'',
                        unicerCollegesCode:'',
                        studyColleges:'',
                        studyCollegesCode:'',
                        studyMajor:'',
                        examMajor:'',
                        studyCode:'',
                        reward:'',
                        speciality:'',
                        remark:'',
                        studySequence:'',
                        status:'',
                        examineName:'',
                        examineTime:'',
                        examineRemark:'',
                        updateTime:'',
                        createTime:''
                },
                rules: {
                          sequence: [
                                  { required: true, message: '请输入序号', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studentId: [
                                  { required: true, message: '请输入学号', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          name: [
                                  { required: true, message: '请输入考生姓名', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          idCard: [
                                  { required: true, message: '请输入身份证号', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          birthday: [
                                  { required: true, message: '请输入出生日期', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          sex: [
                                  { required: true, message: '请输入性别', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          nation: [
                                  { required: true, message: '请输入民族', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          politicalAffiliation: [
                                  { required: true, message: '请输入政治面貌', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          faceImg: [
                                  { required: true, message: '请输入照片', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          phone: [
                                  { required: true, message: '请输入联系电话', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          adressCode: [
                                  { required: true, message: '请输入邮编', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          address: [
                                  { required: true, message: '请输入联系地址', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          ticketNumber: [
                                  { required: true, message: '请输入准考证号', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          password: [
                                  { required: true, message: '请输入登录密码', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          univerColleges: [
                                  { required: true, message: '请输入毕业学校', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          unicerCollegesCode: [
                                  { required: true, message: '请输入毕业学校', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studyColleges: [
                                  { required: true, message: '请输入报考院校', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studyCollegesCode: [
                                  { required: true, message: '请输入报考院校', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studyMajor: [
                                  { required: true, message: '请输入毕业专业', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          examMajor: [
                                  { required: true, message: '请输入报考专业', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studyCode: [
                                  { required: true, message: '请输入高考报名', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          reward: [
                                  { required: true, message: '请输入在校期间', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          speciality: [
                                  { required: true, message: '请输入特长', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          remark: [
                                  { required: true, message: '请输入备注', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studySequence: [
                                  { required: true, message: '请输入报名序号', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          status: [
                                  { required: true, message: '请输入审核状态', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          examineName: [
                                  { required: true, message: '请输入审核人', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          examineTime: [
                                  { required: true, message: '请输入审核时间', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          examineRemark: [
                                  { required: true, message: '请输入审核备注', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          updateTime: [
                                  { required: true, message: '请输入修改时间', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          createTime: [
                                  { required: true, message: '请输入创建时间', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                }
            }
        },
        created(){
          if(this.title=='修改'){
              axios({
                  url:`${home}/sysStudent/update/findSysStudentById/${this.id}`,
                  method:'GET'
              }).then(res=>{
                  Object.assign(this.upsertForm,res.data);
              }).catch(error=>{

              })
          }
        },
        mounted(){

        },
        methods:{
            saveOrUpdate(formName){
                this.$refs[formName].validate(valid=>{
                    if(valid){
                        axios({
                            url:`${home}/sysStudent/${this.title==='增加'?'saveSysStudent':'update/updateSysStudent'}`,
                            method:'POST',
                            data:this.upsertForm
                        }).then(res=>{
                            this.$message({
                                message: this.title+'成功',
                                type: 'success'
                            });
                            this.$emit('closeSaveOrUpdate',true);
                        }).catch(error=>{
                            //do something
                        })


                    }
                })
            },
            close(){
                this.$emit('closeSaveOrUpdate');
            }
        }
    }
</script>

<style scoped lang="scss">
    .saveOrUpdateCrud{
        margin: 20px 0 0 10px;
    }
</style>